import { Document, Page, PDFViewer, Text as RendererText, View, StyleSheet, Image } from '@react-pdf/renderer'
import { Modal, QRCode } from 'antd'
import dayjs from 'dayjs';
import JsBarcode from 'jsbarcode';

const styles = StyleSheet.create({
    page: {
        padding: 30,
        fontSize: 10,
        fontFamily: 'Helvetica',
    },
    section: {
        // padding: 10,
    },
    heading: {
        fontSize: 10,
        fontWeight: 'bold',
        marginBottom: 4,
        backgroundColor: '#000000',
        padding: 4,
        color: 'white'
    },
    box: {
        border: '1pt solid black',
        // padding: 8,
        // marginBottom: 10,
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: 6
    },
    bold: {
        fontWeight: 'bold',
    },
})

const Text = ({ children, style }) => <RendererText style={[{paddingBottom: 5}, style]}>{children}</RendererText>;

const generateBarcode = (value) => {
    const canvas = document.createElement('canvas');
    JsBarcode(canvas, value, { format: 'CODE128' });
    return canvas.toDataURL('image/png');
};

function ShippingLabel({ isShow, setIsShow, selectedOrder }) {
    return (
        <div>
            <Modal
                centered
                maskClosable={false}
                open={isShow}
                onOk={() => setIsShow(false)}
                onCancel={() => setIsShow(false)}
                width={700}
                styles={{ body: { maxHeight: "600px", overflowY: "auto", paddingRight: 5 } }}
            >
                <PDFViewer width="100%" height="600">
                    <Document>
                        <Page size="A5" style={styles.page}>
                            <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                {/* Sender */}
                                <View style={[styles.box, styles.section, { flex: 1, height: '100%' }]}>
                                    <Text style={styles.heading}>From:</Text>
                                    <View style={{ padding: 10 }}>
                                        <Text>{"Weda Arana Ayurweda \nNishpadana"}</Text>
                                        <Text>{"Gettuwana Road, \nKurunegala"}</Text>
                                        <Text>{"+94767064019"}</Text>
                                    </View>
                                </View>

                                {/* Receiver */}
                                <View style={[styles.box, styles.section, { flex: 1, height: '100%' }]}>
                                    <Text style={styles.heading}>Ship To:</Text>
                                    <View style={{ padding: 10 }}>
                                        <Text style={styles.bold}>{selectedOrder?.shipping?.name}</Text>
                                        <Text>{selectedOrder?.shipping?.address}</Text>
                                        <Text>{selectedOrder?.shipping?.telephone}</Text>
                                    </View>
                                </View>
                            </View>

                            {/* Order Info */}
                            <View style={[styles.box, styles.section]}>
                                <Text style={styles.heading}>Order Details</Text>
                                <View style={styles.row}>
                                    <View style={{ padding: 10 }}>
                                        <Text>Order ID: {selectedOrder?.id}</Text>
                                        <Text>Shipping Date: {dayjs().format("YYYY-MM-DD")}</Text>
                                        {/* <Text>Tracking URL: https://wedaarana.com/trace-order</Text> */}
                                        <Text>Tracking No: {selectedOrder?.orderTrackingNumber || "N/A"}</Text>
                                    </View>
                                    <Image style={{ height: 80 }} src={generateBarcode(selectedOrder?.orderTrackingNumber || "N/A")} />
                                </View>
                            </View>
                        </Page>
                    </Document>
                </PDFViewer>
            </Modal>
        </div>
    )
}

export default ShippingLabel
